import { render, staticRenderFns } from "./NoPer.vue?vue&type=template&id=81561c46&scoped=true"
import script from "./NoPer.vue?vue&type=script&lang=js"
export * from "./NoPer.vue?vue&type=script&lang=js"
import style0 from "./NoPer.vue?vue&type=style&index=0&id=81561c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81561c46",
  null
  
)

export default component.exports